// extracted by mini-css-extract-plugin
module.exports = {"container":"Info_container__3aq0c","header":"Info_header__23HLp","info":"Info_info__33dU2","divider":"Info_divider___Vif1"};